export default class Routes {
  public static get OpsHub(): string {
    return '/ops-hub'
  }

  public static get opsHubDashboardPageURL(): string {
    return 'board'
  }

  public static get customer(): string {
    return 'customer'
  }

  public static get userCidnAssociation(): string {
    return 'user-cidn-association'
  }

  public static get userDetails(): string {
    return 'user-details'
  }

  public static get customerCustomProps(): string {
    return 'customer-custom-props'
  }

  public static get userCustomProps(): string {
    return 'user-custom-props'
  }
  public static get userActivationToggle(): string {
    return 'user-activation-toggle'
  }

  public static get updateFeatureflags(): string {
    return 'update-feature-flags'
  }

}
